import axios from 'axios';

class WidgetService {
    constructor() {
        this.baseURL = `${import.meta.env.VITE_API_BASE_URL}/cpanel/widgets`;
    }
    async createWidget(widgetData) {
        try {
            const response = await axios.post(this.baseURL, widgetData, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to create widget');
            throw error;
        }
    }

    async getAllWidgets() {
        try {
            const response = await axios.get(this.baseURL, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to get all widgets');
            throw error;
        }
    }

    async getWidget(uuid) {
        try {
            const response = await axios.get(`${this.baseURL}/${uuid}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to get widget');
            throw error;
        }
    }

    async getWidgetsByType(type) {
        try {
            const response = await axios.get(`${this.baseURL}/type/${type}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to get widgets by type');
            throw error;
        }
    }

    async updateWidget(uuid, updateData) {
        try {
            const response = await axios.patch(`${this.baseURL}/${uuid}`, updateData, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            this.handleError(error, 'Failed to update widget');
            throw error;
        }
    }

    async deleteWidget(uuid) {
        try {
            await axios.delete(`${this.baseURL}/${uuid}`, {
                withCredentials: true,
            });
        } catch (error) {
            this.handleError(error, 'Failed to delete widget');
            throw error;
        }
    }

    async updateWidgetState(uuid, state) {
        return this.updateWidget(uuid, { state });
    }

    async updateWidgetName(uuid, name) {
        return this.updateWidget(uuid, { name });
    }

    async getOrCreateWidget(uuid, defaultWidget) {
        try {
            return await this.getWidget(uuid);
        } catch (error) {
            if (error.response?.status === 404) {
                return await this.createWidget(defaultWidget);
            }
            throw error;
        }
    }

    handleError(error, message) {
        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;

            switch (status) {
                case 400:
                    console.error(`${message}: Invalid data`, data);
                    break;
                case 401:
                    console.error(`${message}: Authentication required`);
                    break;
                case 404:
                    console.error(`${message}: Widget not found`);
                    break;
                case 500:
                    console.error(`${message}: Server error`, data);
                    break;
                default:
                    console.error(`${message}: HTTP ${status}`, data);
            }
        } else if (error.request) {
            console.error(`${message}: Network error`, error.request);
        } else {
            console.error(`${message}:`, error.message);
        }
    }
}

const widgetService = new WidgetService();
export default widgetService;

export { WidgetService };
